export type PersonaId =
  | 'content_creator'
  | 'cleaner'
  | 'electrician'
  | 'painter'
  | 'hair_stylist'
  | 'daycare'
  | 'healthcare'
  | 'plumber'
  | 'mechanic'
  | 'mover'
  | 'gardener'
  | 'tutor'
  | 'caterer'
  | 'trainer'
  | 'photographer'
  | 'designer'
  | 'developer'
  | 'videographer'
  | 'dj'
  | 'legal'
  | 'other';

export type PersonaBucket = 'social' | 'trade';

export type Persona = {
  id: PersonaId;
  label: string;
   bucket: PersonaBucket;
};

export const DEFAULT_PERSONA_ID: PersonaId = 'other';
export const DEFAULT_PERSONA_BUCKET: PersonaBucket = 'trade';

export const PERSONAS: Persona[] = [
  {
    id: 'content_creator',
    label: 'Content Creator / Promoter',
    bucket: 'social',
  },
  {
    id: 'cleaner',
    label: 'House Cleaner / Maid',
    bucket: 'trade',
  },
  {
    id: 'electrician',
    label: 'Electrician',
    bucket: 'trade',
  },
  {
    id: 'painter',
    label: 'Painter',
    bucket: 'trade',
  },
  {
    id: 'hair_stylist',
    label: 'Hair, Nails & Beauty',
    bucket: 'social',
  },
  {
    id: 'daycare',
    label: 'Daycare / Childcare',
    bucket: 'trade',
  },
  {
    id: 'healthcare',
    label: 'Nurse / Home Care',
    bucket: 'trade',
  },
  {
    id: 'plumber',
    label: 'Plumber',
    bucket: 'trade',
  },
  {
    id: 'mechanic',
    label: 'Mechanic',
    bucket: 'trade',
  },
  {
    id: 'mover',
    label: 'Mover / Delivery',
    bucket: 'trade',
  },
  {
    id: 'gardener',
    label: 'Gardener / Landscaper',
    bucket: 'trade',
  },
  { id: 'tutor', label: 'Tutor', bucket: 'trade' },
  {
    id: 'caterer',
    label: 'Caterer / Private Chef',
    bucket: 'trade',
  },
  {
    id: 'trainer',
    label: 'Personal Trainer',
    bucket: 'social',
  },
  {
    id: 'photographer',
    label: 'Photographer',
    bucket: 'social',
  },
  {
    id: 'designer',
    label: 'Graphic Designer',
    bucket: 'social',
  },
  {
    id: 'developer',
    label: 'Developer',
    bucket: 'social',
  },
  {
    id: 'videographer',
    label: 'Videographer',
    bucket: 'social',
  },
  {
    id: 'dj',
    label: 'DJ / Musician',
    bucket: 'social',
  },
  {
    id: 'legal',
    label: 'Lawyer / Tax Consultant',
    bucket: 'trade',
  },
  {
    id: 'other',
    label: 'Something else',
    bucket: 'trade',
  },
];

export const findPersona = (id: PersonaId | null): Persona => {
  const found = PERSONAS.find((persona) => persona.id === id);
  return found ?? PERSONAS[PERSONAS.length - 1];
};
